"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Path = exports.pathDirectionArray = void 0;
/*
 * Copyright 2022, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const cloneDeep_1 = __importDefault(require("lodash/cloneDeep"));
const get_1 = __importDefault(require("lodash/get"));
const mean_1 = __importDefault(require("lodash/mean"));
const isNumber_1 = __importDefault(require("lodash/isNumber"));
const isFinite_1 = __importDefault(require("lodash/isFinite"));
const turf_1 = require("@turf/turf");
const Status = __importStar(require("chaire-lib-common/lib/utils/Status"));
const MapObject_1 = require("chaire-lib-common/lib/utils/objects/MapObject");
const PathGeographyUtils_1 = __importDefault(require("./PathGeographyUtils"));
const Preferences_1 = __importDefault(require("chaire-lib-common/lib/config/Preferences"));
const LodashExtensions_1 = require("chaire-lib-common/lib/utils/LodashExtensions");
const MathUtils_1 = require("chaire-lib-common/lib/utils/MathUtils");
// TODO Should not be needed
// import ODProximityLineGenerator from './generators/ODProximityLineGenerator';
const lineModes_1 = __importDefault(require("../../config/lineModes"));
const SaveUtils_1 = __importDefault(require("chaire-lib-common/lib/services/objects/SaveUtils"));
const TrError_1 = __importDefault(require("chaire-lib-common/lib/utils/TrError"));
const lineModesConfigByMode = {};
for (let i = 0, countI = lineModes_1.default.length; i < countI; i++) {
    const lineMode = lineModes_1.default[i];
    lineModesConfigByMode[lineMode.value] = lineMode;
}
exports.pathDirectionArray = ['loop', 'outbound', 'inbound', 'other'];
/**
 * Specific sequence of stops associated with a line. Has a sequence of nodes
 * (less precise) or stops (more precise)
 *
 * TODO: Test coverage is very limited, but many methods might be moved to a
 * utility service instead of being in this class. Node insertion/update could
 * easily be further tested
 */
class Path extends MapObject_1.MapObject {
    /** When true, the next geography update recalculates all segments from OSRM instead of preserving previous times. */
    setForceRecalculate(value) {
        this._forceRecalculate = value;
    }
    constructor(attributes = {}, isNew, collectionManager) {
        super(attributes, isNew, collectionManager);
        this._forceRecalculate = false;
        if ((0, LodashExtensions_1._isBlank)(this._attributes.data.variables)) {
            this.refreshStats();
        }
        this.setDefaultValues();
    }
    _prepareAttributes(attributes) {
        if (!attributes.data) {
            attributes.data = {
                waypoints: [],
                waypointTypes: [],
                nodeTypes: []
            };
        }
        else {
            if (!attributes.data.waypoints) {
                attributes.data.waypoints = [];
            }
            if (!attributes.data.waypointTypes) {
                attributes.data.waypointTypes = [];
            }
        }
        if ((0, LodashExtensions_1._isBlank)(attributes.data.variables)) {
            attributes.data.variables = {};
        }
        attributes.nodes = attributes.nodes || [];
        attributes.segments = attributes.segments || [];
        return super._prepareAttributes(attributes);
    }
    getClonedAttributes(deleteSpecifics = true) {
        var _a;
        const newAttributes = super.getClonedAttributes(deleteSpecifics);
        (_a = newAttributes.data) === null || _a === void 0 ? true : delete _a.gtfs;
        return newAttributes;
    }
    setDefaultValues() {
        if (!this.attributes.data.nodeTypes || this.countNodes() !== this.attributes.data.nodeTypes.length) {
            const nodeTypes = [];
            for (let i = 0, count = this.countNodes(); i < count; i++) {
                nodeTypes.push(this.attributes.data.defaultRoutingEngine || 'engine');
            }
            this.attributes.data.nodeTypes = nodeTypes;
        }
        const line = this.getLine();
        const mode = this.getMode();
        if ((0, LodashExtensions_1._isBlank)(this.attributes.direction) && (line === null || line === void 0 ? void 0 : line.paths) && (line === null || line === void 0 ? void 0 : line.paths.length) === 0) {
            this.attributes.direction = 'outbound';
        }
        const preferencesDefaultValues = Preferences_1.default.get('transit.paths', {});
        for (const defaultValueAttribute in preferencesDefaultValues) {
            if (defaultValueAttribute === 'data') {
                for (const defaultDataValueAttribute in preferencesDefaultValues.data) {
                    if ((0, LodashExtensions_1._isBlank)(this.attributes.data[defaultDataValueAttribute])) {
                        this.attributes.data[defaultDataValueAttribute] =
                            preferencesDefaultValues.data[defaultDataValueAttribute];
                    }
                }
            }
            else if (defaultValueAttribute !== 'generator') {
                // ignore generator default values
                if ((0, LodashExtensions_1._isBlank)(this.attributes[defaultValueAttribute])) {
                    this.attributes[defaultValueAttribute] = preferencesDefaultValues[defaultValueAttribute];
                }
            }
        }
        if (!(0, LodashExtensions_1._isBlank)(mode)) {
            for (const defaultValueAttribute in lineModesConfigByMode[mode].defaultValues) {
                if (defaultValueAttribute === 'data') {
                    for (const defaultDataValueAttribute in lineModesConfigByMode[mode].defaultValues.data) {
                        if ((0, LodashExtensions_1._isBlank)(this.attributes.data[defaultDataValueAttribute])) {
                            this.attributes.data[defaultDataValueAttribute] = Preferences_1.default.get(`transit.lines.lineModesDefaultValues.${mode}.${defaultDataValueAttribute}`, lineModesConfigByMode[mode].defaultValues.data[defaultDataValueAttribute]);
                        }
                    }
                }
                else {
                    if ((0, LodashExtensions_1._isBlank)(this.attributes[defaultValueAttribute])) {
                        this.attributes[defaultValueAttribute] =
                            lineModesConfigByMode[mode].defaultValues[defaultValueAttribute];
                    }
                }
            }
        }
    }
    get collectionManager() {
        return this._collectionManager;
    }
    isFrozen() {
        if (super.isFrozen()) {
            return true;
        }
        const line = this.getLine();
        return line ? line.isFrozen() : false;
    }
    toGeojson() {
        //LineStringUtils.offset(
        return {
            id: this.attributes.integer_id,
            geometry: this.attributes.geography,
            type: 'Feature',
            properties: this.attributes
        };
    }
    /* This is used for manual routing only: when you import from a gtfs,
       the coordinates are imported from the shape.
       However, if routing engine is manual (click on map), we loose the
       waypoints, so when we refresh the path, it will just draw a straight
       line. This method converts the coordinates to waypoints so we can
       keep them and keep the imported shape after refreshing the path.
       returns null if routing engine is not manual and force is not true.
       If force param is set to true, the waypoints will be added even
       if the routing engine is not manual.
       Modes that do not accept waypoints leave the path unchanged.
       TODO: testing!
    */
    convertAllCoordinatesToWaypoints(force = false) {
        if (!this.allowsWaypoints()) {
            return;
        }
        const routingEngine = this.attributes.data.routingEngine || 'engine';
        if (force || routingEngine === 'manual') {
            const globalCoordinates = this.attributes.geography.coordinates;
            const globalCoordinatesLength = globalCoordinates.length;
            const nodesCount = this.countNodes();
            const segments = this.attributes.segments;
            const segmentsCount = segments.length;
            const nodeTypes = [];
            const waypointsByNodeIndex = [];
            const waypointTypesByNodeIndex = [];
            for (let i = 0; i < nodesCount; i++) {
                nodeTypes.push(routingEngine);
            }
            let coordinateIndex = 0;
            for (let i = 0; i < segmentsCount - 1; i++) {
                waypointsByNodeIndex[i] = [];
                waypointTypesByNodeIndex[i] = [];
                const segment = segments[i];
                const nextSegment = segments[i + 1];
                const coordinatesLength = nextSegment - segment;
                for (let j = 0; j < coordinatesLength; j++) {
                    waypointsByNodeIndex[i].push(globalCoordinates[coordinateIndex]);
                    waypointTypesByNodeIndex[i].push(routingEngine);
                    coordinateIndex++;
                }
            }
            waypointsByNodeIndex.push([]);
            waypointTypesByNodeIndex.push([]);
            // add last segment:
            for (let i = coordinateIndex; i < globalCoordinatesLength; i++) {
                waypointsByNodeIndex[waypointsByNodeIndex.length - 1].push(globalCoordinates[i]);
                waypointTypesByNodeIndex[waypointTypesByNodeIndex.length - 1].push(routingEngine);
            }
            // save waypoints:
            this._attributes.data.nodeTypes = nodeTypes;
            this._attributes.data.waypoints = waypointsByNodeIndex;
            this._attributes.data.waypointTypes = waypointTypesByNodeIndex;
            this._updateHistory();
        }
    }
    removeConsecutiveDuplicateNodes() {
        const nodeIds = this.attributes.nodes;
        const nodesTypes = this.attributes.data.nodeTypes;
        const waypoints = this.attributes.data.waypoints;
        const waypointTypes = this.attributes.data.waypointTypes;
        const nodesCount = nodeIds.length;
        const cleanedNodeIds = [nodeIds[0]];
        const cleanedNodesTypes = [nodesTypes[0]];
        const cleanedWaypoints = [waypoints[0]];
        const cleanedWaypointTypes = [waypointTypes[0]];
        for (let i = 1; i < nodesCount; i++) {
            if (nodeIds[i] !== nodeIds[i - 1]) {
                cleanedNodeIds.push(nodeIds[i]);
                cleanedNodesTypes.push(nodesTypes[i]);
                cleanedWaypoints.push(waypoints[i]);
                cleanedWaypointTypes.push(waypointTypes[i]);
            }
        }
        this._attributes.nodes = cleanedNodeIds;
        this._attributes.data.nodeTypes = cleanedNodesTypes;
        this._attributes.data.waypoints = cleanedWaypoints;
        this._attributes.data.waypointTypes = cleanedWaypointTypes;
    }
    /**
     * Insert a node ID at a specific location
     * @param nodeId The ID of the node to insert
     * @param insertIndex The index at which to insert the node
     * @param nodeType The type of this node. Defaults to `engine`
     * @returns The updated path
     */
    insertNodeId(nodeId, insertIndex, nodeType = 'engine') {
        const nodeIds = this.attributes.nodes;
        const nodeTypes = this.attributes.data.nodeTypes || [];
        const waypointsByNodeIndex = this.attributes.data.waypoints || [];
        const waypointTypesByNodeIndex = this.attributes.data.waypointTypes || [];
        if (insertIndex === undefined || insertIndex === null) {
            insertIndex = nodeIds.length;
            nodeIds.push(nodeId);
            nodeTypes.push(nodeType);
            waypointsByNodeIndex.push([]);
            waypointTypesByNodeIndex.push([]);
        }
        else {
            nodeIds.splice(insertIndex, 0, nodeId);
            nodeTypes.splice(insertIndex, 0, nodeType);
            waypointsByNodeIndex.splice(insertIndex, 0, []);
            waypointTypesByNodeIndex.splice(insertIndex, 0, []);
        }
        this._attributes.nodes = nodeIds;
        this._attributes.data.nodeTypes = nodeTypes;
        this._attributes.data.waypoints = waypointsByNodeIndex;
        this._attributes.data.waypointTypes = waypointTypesByNodeIndex;
        this.removeConsecutiveDuplicateNodes();
        this._updateHistory();
        return this.updateGeography({ lastNodeChange: { type: 'insert', index: insertIndex } });
    }
    /**
     * Remove a node in the path, identified by ID
     * @param removeNodeId The ID of the node to remove
     * @returns the updated path
     */
    removeNodeId(removeNodeId) {
        return __awaiter(this, void 0, void 0, function* () {
            // only if only one instance of the node in path
            const nodeIds = this.attributes.nodes;
            let countInstancesOfNodeId = 0;
            let removeNodeIndex = -1;
            nodeIds.forEach((nodeId, nodeIdx) => {
                if (nodeId === removeNodeId) {
                    countInstancesOfNodeId++;
                    removeNodeIndex = nodeIdx;
                }
            });
            if (countInstancesOfNodeId === 1 && removeNodeIndex >= 0) {
                return this.removeNode(removeNodeIndex);
            }
            // can't remove node (doesn't exist or at least two instances of the node in the path)
            return { path: this };
        });
    }
    /**
     * Remove a node from the path, identified by its index in the path
     * @param removeIndex The index of the node to remove
     * @returns The updated path
     */
    removeNode(removeIndex) {
        return __awaiter(this, void 0, void 0, function* () {
            const nodeIds = this.attributes.nodes;
            const nodeTypes = this.attributes.data.nodeTypes;
            let recomputePath = false;
            if (nodeIds.length > 0 && removeIndex < nodeIds.length) {
                nodeIds.splice(removeIndex, 1);
                nodeTypes.splice(removeIndex, 1);
                this.attributes.nodes = nodeIds;
                this.attributes.data.nodeTypes = nodeTypes;
                // `waypoints[k]` / `waypointTypes[k]` are for the segment from node k to k+1. Removing node
                // `removeIndex` joins that segment with the next; concatenate their waypoints in path order.
                // If we remove the first node, it will delete the first segment, so the existing waypoints
                // in this removed segment will be deleted too, as they should be.
                const waypointsByNodeIndex = this.attributes.data.waypoints;
                const waypointTypesByNodeIndex = this.attributes.data.waypointTypes;
                let mergedWaypoints;
                let mergedWaypointTypes;
                if (removeIndex > 0) {
                    mergedWaypoints = [
                        ...(waypointsByNodeIndex[removeIndex - 1] || []),
                        ...(waypointsByNodeIndex[removeIndex] || [])
                    ];
                    mergedWaypointTypes = [
                        ...(waypointTypesByNodeIndex[removeIndex - 1] || []),
                        ...(waypointTypesByNodeIndex[removeIndex] || [])
                    ];
                }
                waypointsByNodeIndex.splice(removeIndex, 1);
                waypointTypesByNodeIndex.splice(removeIndex, 1);
                if (removeIndex > 0 && mergedWaypoints !== undefined && mergedWaypointTypes !== undefined) {
                    waypointsByNodeIndex[removeIndex - 1] = mergedWaypoints;
                    waypointTypesByNodeIndex[removeIndex - 1] = mergedWaypointTypes;
                }
                this._attributes.nodes = nodeIds;
                this._attributes.data.nodeTypes = nodeTypes;
                this._attributes.data.waypoints = waypointsByNodeIndex;
                this._attributes.data.waypointTypes = waypointTypesByNodeIndex;
                if (nodeIds.length > 1) {
                    this.removeConsecutiveDuplicateNodes();
                }
                recomputePath = true;
            }
            else if (nodeIds.length === 0) {
                // Path has no nodes, make sure all data is initialized
                this.attributes.nodes = [];
                this.attributes.data.nodeTypes = [];
                this.attributes.data.waypoints = [];
                this.attributes.data.waypointTypes = [];
                //this.emptyGeography();
            }
            else {
                // No node at index
                return { path: this };
            }
            this._updateHistory();
            return recomputePath
                ? this.updateGeography({ lastNodeChange: { type: 'remove', index: removeIndex } })
                : { path: this };
        });
    }
    /**
     * Insert a waypoint at a given location
     *
     * @param waypointCoordinates The coordinates of the waypoint to insert
     * @param waypointType The type of the waypoint
     * @param afterNodeIndex The index of the node after which to insert this
     * waypoint. If not set, it is added at the end of the path
     * @param insertIndex The index at which to insert this waypoint. If not
     * set, it is added at the end of the waypoints for this path
     * @returns The updated path. When the mode does not accept waypoints,
     * the path is unchanged and geography is not recalculated.
     */
    insertWaypoint(waypointCoordinates_1) {
        return __awaiter(this, arguments, void 0, function* (waypointCoordinates, waypointType = 'engine', afterNodeIndex, insertIndex) {
            if (!this.allowsWaypoints()) {
                return { path: this };
            }
            const nodeIds = this.attributes.nodes;
            //console.log('inserting waypoint', waypointCoordinates, 'after node index: ' + afterNodeIndex + ' at insert index: ' + insertIndex);
            let afterNodeWaypoints;
            let afterNodeWaypointTypes;
            if ((0, LodashExtensions_1._isBlank)(insertIndex) && !(0, LodashExtensions_1._isBlank)(afterNodeIndex)) {
                afterNodeWaypoints = this.attributes.data.waypoints[afterNodeIndex] || [];
                afterNodeWaypointTypes = this.attributes.data.waypointTypes[afterNodeIndex] || [];
                afterNodeWaypoints.push(waypointCoordinates);
                afterNodeWaypointTypes.push(waypointType);
            }
            else if (!(0, LodashExtensions_1._isBlank)(insertIndex) && !(0, LodashExtensions_1._isBlank)(afterNodeIndex)) {
                afterNodeWaypoints = this.attributes.data.waypoints[afterNodeIndex] || [];
                afterNodeWaypointTypes = this.attributes.data.waypointTypes[afterNodeIndex] || [];
                afterNodeWaypoints.splice(insertIndex, 0, waypointCoordinates);
                afterNodeWaypointTypes.splice(insertIndex, 0, waypointType);
            }
            else if (this.attributes.geography === undefined) {
                // No geography, insert at the end, or don't insert if path is empty
                if (this.attributes.nodes.length === 0) {
                    return { path: this };
                }
                afterNodeIndex = this.attributes.nodes.length - 1;
                afterNodeWaypoints = this.attributes.data.waypoints[afterNodeIndex] || [];
                afterNodeWaypointTypes = this.attributes.data.waypointTypes[afterNodeIndex] || [];
                afterNodeWaypoints.push(waypointCoordinates);
                afterNodeWaypointTypes.push(waypointType);
            }
            else {
                // we need to determine where to put waypoint on path, if the point is close enough to the line, take this point
                // TODO Move the search of the best location out of this function and add the waypoint at the end of the path is indexes are not set instead
                const waypointsByNodeIndex = this.attributes.data.waypoints;
                const waypointTypesByNodeIndex = this.attributes.data.waypointTypes;
                const globalCoordinates = this.attributes.geography.coordinates;
                const segmentBeforeWaypoint = (0, turf_1.lineSlice)(turf_1.helpers.point(globalCoordinates[0]), turf_1.helpers.point(waypointCoordinates), turf_1.helpers.lineString(globalCoordinates));
                const segmentBeforeWaypointLength = (0, turf_1.length)(segmentBeforeWaypoint, { units: 'meters' });
                //console.log('segmentBeforeLength', segmentBeforeWaypointLength, 'segmentBeforeCoordinates', segmentBeforeWaypoint.geometry.coordinates, 'globalCoordinates', globalCoordinates);
                afterNodeIndex = undefined;
                insertIndex = 0;
                const segments = this.attributes.segments;
                let segmentsLengthSoFar = 0;
                for (let i = 0, count = segments.length; i < count; i++) {
                    const segmentGeojson = this.segmentGeojson(i, i + 1);
                    segmentsLengthSoFar += (0, turf_1.length)(segmentGeojson, { units: 'meters' });
                    if (segmentsLengthSoFar > segmentBeforeWaypointLength) {
                        //console.log(i, "segmentsLengthSoFar", segmentsLengthSoFar, 'segmentBeforeWaypointLength', segmentBeforeWaypointLength);
                        afterNodeIndex = i;
                        break;
                    }
                }
                if (afterNodeIndex === undefined) {
                    afterNodeIndex = nodeIds.length - 1;
                }
                //console.log('inserted waypoint will be after node index', afterNodeIndex);
                afterNodeWaypoints = waypointsByNodeIndex[afterNodeIndex] || [];
                afterNodeWaypointTypes = waypointTypesByNodeIndex[afterNodeIndex] || [];
                const segmentGeojson = this.segmentGeojson(afterNodeIndex, afterNodeIndex + 1);
                for (let i = 0, count = afterNodeWaypoints.length; i < count; i++) {
                    const waypoint = afterNodeWaypoints[i];
                    const segmentBeforeExistingWaypoint = (0, turf_1.lineSlice)(turf_1.helpers.point(segmentGeojson.geometry.coordinates[0]), turf_1.helpers.point(waypoint), segmentGeojson);
                    const segmentBeforeExistingLength = (0, turf_1.length)(segmentBeforeExistingWaypoint, { units: 'meters' });
                    const segmentBeforeWaypoint = (0, turf_1.lineSlice)(turf_1.helpers.point(segmentGeojson.geometry.coordinates[0]), turf_1.helpers.point(waypointCoordinates), segmentGeojson);
                    const segmentBeforeLength = (0, turf_1.length)(segmentBeforeWaypoint, { units: 'meters' });
                    if (segmentBeforeLength >= segmentBeforeExistingLength) {
                        insertIndex = i + 1;
                        //console.log('inserted waypoint will be after waypoint index', insertIndex);
                        //break;
                    }
                    else {
                        break;
                    }
                }
                if (!(0, LodashExtensions_1._isBlank)(insertIndex) && !(0, LodashExtensions_1._isBlank)(afterNodeIndex)) {
                    afterNodeWaypoints.splice(insertIndex, 0, waypointCoordinates);
                    afterNodeWaypointTypes.splice(insertIndex, 0, waypointType);
                }
            }
            this._attributes.data.waypoints[afterNodeIndex] = afterNodeWaypoints;
            this._attributes.data.waypointTypes[afterNodeIndex] = afterNodeWaypointTypes;
            this._updateHistory();
            return this.updateGeography({ lastWaypointChangedSegmentIndex: afterNodeIndex });
        });
    }
    /**
     * Replace waypoint coordinates by new ones. If the waypoint does not exist,
     * the path is not changed.
     *
     * @param waypointCoordinates The new coordinates of the waypoint
     * @param waypointType The type of this updated waypoint
     * @param afterNodeIndex The index of the node after which the waypoint is
     * located
     * @param waypointIndex The index of the waypoint to update
     * @returns The updated path. When the mode does not accept waypoints,
     * the path is unchanged and geography is not recalculated.
     */
    updateWaypoint(waypointCoordinates_1) {
        return __awaiter(this, arguments, void 0, function* (waypointCoordinates, waypointType = undefined, afterNodeIndex, waypointIndex) {
            if (!this.allowsWaypoints()) {
                return { path: this };
            }
            // Make sure waypoint exists
            if ((0, LodashExtensions_1._isBlank)(this.attributes.data.waypoints[afterNodeIndex]) ||
                (0, LodashExtensions_1._isBlank)(this.attributes.data.waypoints[afterNodeIndex][waypointIndex])) {
                // Waypoint does not exist, just return
                return { path: this };
            }
            const afterNodeWaypoints = this.attributes.data.waypoints[afterNodeIndex];
            const afterNodeWaypointTypes = this.attributes.data.waypointTypes[afterNodeIndex];
            afterNodeWaypoints[waypointIndex] = waypointCoordinates;
            afterNodeWaypointTypes[waypointIndex] = waypointType || afterNodeWaypointTypes[waypointIndex] || 'engine';
            this.attributes.data.waypoints[afterNodeIndex] = afterNodeWaypoints;
            this.attributes.data.waypointTypes[afterNodeIndex] = afterNodeWaypointTypes;
            this._updateHistory();
            return this.updateGeography({ lastWaypointChangedSegmentIndex: afterNodeIndex });
        });
    }
    /**
     * Replace a waypoint by a transit node. The node is expected to exist. If
     * the waypoint does not exit, the path is not changed
     * @param nodeId The ID of the node to replace
     * @param afterNodeIndex The index of the node after which the waypoint to
     * replace is located
     * @param waypointIndex The index of the waypoint to replace
     * @param waypointType The type of the node
     * @returns The updated path.
     */
    replaceWaypointByNodeId(nodeId_1, afterNodeIndex_1, waypointIndex_1) {
        return __awaiter(this, arguments, void 0, function* (nodeId, afterNodeIndex, waypointIndex, waypointType = 'engine') {
            // Make sure waypoint exists
            if ((0, LodashExtensions_1._isBlank)(this.attributes.data.waypoints[afterNodeIndex]) ||
                (0, LodashExtensions_1._isBlank)(this.attributes.data.waypoints[afterNodeIndex][waypointIndex])) {
                // Waypoint does not exist, just return
                return { path: this };
            }
            const waypointsByNodeIndex = this.attributes.data.waypoints;
            const waypointTypesByNodeIndex = this.attributes.data.waypointTypes;
            const afterNodeWaypoints = waypointsByNodeIndex[afterNodeIndex];
            const afterNodeWaypointTypes = waypointTypesByNodeIndex[afterNodeIndex];
            const waypointsBefore = afterNodeWaypoints.slice(0, waypointIndex);
            const waypointTypesBefore = afterNodeWaypointTypes.slice(0, waypointIndex);
            const waypointsAfter = afterNodeWaypoints.slice(waypointIndex + 1);
            const waypointTypesAfter = afterNodeWaypointTypes.slice(waypointIndex + 1);
            const nodeIds = this.attributes.nodes;
            const nodeTypes = this.attributes.data.nodeTypes;
            nodeIds.splice(afterNodeIndex + 1, 0, nodeId);
            nodeTypes.splice(afterNodeIndex + 1, 0, waypointType);
            waypointsByNodeIndex.splice(afterNodeIndex + 1, 0, waypointsAfter);
            waypointTypesByNodeIndex.splice(afterNodeIndex + 1, 0, waypointTypesAfter);
            waypointsByNodeIndex[afterNodeIndex] = waypointsBefore;
            waypointTypesByNodeIndex[afterNodeIndex] = waypointTypesBefore;
            this._attributes.nodes = nodeIds;
            this._attributes.data.nodeTypes = nodeTypes;
            this._attributes.data.waypoints = waypointsByNodeIndex;
            this._attributes.data.waypointTypes = waypointTypesByNodeIndex;
            this.removeConsecutiveDuplicateNodes();
            this._updateHistory();
            return this.updateGeography({ lastNodeChange: { type: 'insert', index: afterNodeIndex + 1 } });
        });
    }
    /**
     * Remove a waypoint. If the waypoint does not exit, the path is not changed
     * @param afterNodeIndex The index of the node after which the waypoint to
     * replace is located
     * @param waypointIndex The index of the waypoint to replace
     * @returns The updated path.
     */
    removeWaypoint(afterNodeIndex, waypointIndex) {
        return __awaiter(this, void 0, void 0, function* () {
            // Make sure waypoint exists
            if ((0, LodashExtensions_1._isBlank)(this.attributes.data.waypoints[afterNodeIndex]) ||
                (0, LodashExtensions_1._isBlank)(this.attributes.data.waypoints[afterNodeIndex][waypointIndex])) {
                // Waypoint does not exist, just return
                return { path: this };
            }
            const afterNodeWaypoints = this.attributes.data.waypoints[afterNodeIndex];
            const afterNodeWaypointTypes = this.attributes.data.waypointTypes[afterNodeIndex];
            afterNodeWaypoints.splice(waypointIndex, 1);
            afterNodeWaypointTypes.splice(waypointIndex, 1);
            this._attributes.data.waypoints[afterNodeIndex] = afterNodeWaypoints;
            this._attributes.data.waypointTypes[afterNodeIndex] = afterNodeWaypointTypes;
            this._updateHistory();
            return this.updateGeography({ lastWaypointChangedSegmentIndex: afterNodeIndex });
        });
    }
    /* Get the time arrival at node index if departure is at 0 seconds (cumulative travel time up to the node).
    TODO: add test
    */
    getCumulativeTimeForNodeIndex(nodeIndex) {
        let tripTimeSoFar = 0;
        const segments = this.attributes.data.segments || [];
        const dwellTimes = this.attributes.data.dwellTimeSeconds || [];
        for (let i = 0; i < nodeIndex; i++) {
            const segment = segments[i];
            const dwellTime = dwellTimes[i];
            if (dwellTime) {
                tripTimeSoFar += dwellTime;
            }
            if (segment && segment.travelTimeSeconds !== null) {
                tripTimeSoFar += segment.travelTimeSeconds;
            }
            else {
                return undefined;
            }
        }
        return tripTimeSoFar;
    }
    /* Get the cumulative distance traveled until the node index .
    TODO: add test
    */
    getCumulativeDistanceForNodeIndex(nodeIndex) {
        let tripDistanceSoFar = 0;
        const segments = this.attributes.data.segments || [];
        for (let i = 0; i < nodeIndex; i++) {
            const segment = segments[i];
            if (segment && segment.distanceMeters !== null) {
                tripDistanceSoFar += segment.distanceMeters;
            }
            else {
                return undefined;
            }
        }
        return tripDistanceSoFar;
    }
    /* Get the distance between the path geography and each node and get the routing radius for each node:
       If any diff (radius - distance) is < 0, that means that the routing may fail or may change when calculating again (take a detour to reach the node with a radius too small for the actual path geography)
       This will mostly happen for paths imported from gtfs or when a node routing radius is changed between path calculations
    */
    getNodesDistancesFromPathWithNodesRoutingRadii(nodeCollection) {
        var _a, _b, _c;
        if (nodeCollection === void 0) { nodeCollection = (_a = this._collectionManager) === null || _a === void 0 ? void 0 : _a.get('nodes'); }
        const nodeIds = this.attributes.nodes;
        const nodesCount = nodeIds.length;
        const coordinates = (_b = this.attributes.geography) === null || _b === void 0 ? void 0 : _b.coordinates;
        const segments = this.attributes.segments;
        if (!nodeCollection ||
            !segments ||
            !coordinates ||
            (0, LodashExtensions_1._isBlank)(coordinates) ||
            coordinates.length - 1 < segments[segments.length - 1] ||
            segments.length < nodesCount - 1 ||
            !nodeCollection) {
            return []; // TODO: throw an error
        }
        const defaultRoutingRadiusMeters = Preferences_1.default.current.transit.nodes.defaultRoutingRadiusMeters;
        const nodesDistancesAndRadiiFromPath = [];
        for (let i = 0; i < nodesCount; i++) {
            const nodeId = nodeIds[i];
            const nodeGeojson = nodeCollection.getById(nodeId);
            if (!nodeGeojson) {
                return []; // TODO: throw an error
            }
            // if last node, use last coordinate if no segment is available:
            const segmentCoordinates = i === nodesCount - 1 && !coordinates[segments[i]]
                ? coordinates[coordinates.length - 1]
                : coordinates[segments[i]];
            const distanceFromNode = (0, turf_1.distance)(turf_1.helpers.point(segmentCoordinates), nodeGeojson, {
                units: 'meters'
            });
            const routingRadiusMeters = ((_c = nodeGeojson === null || nodeGeojson === void 0 ? void 0 : nodeGeojson.properties) === null || _c === void 0 ? void 0 : _c.routing_radius_meters) || defaultRoutingRadiusMeters;
            nodesDistancesAndRadiiFromPath[i] = {
                nodeId,
                distanceMeters: distanceFromNode,
                routingRadiusMeters
            };
        }
        return nodesDistancesAndRadiiFromPath;
    }
    // Any diff (radius-distance) < 5m may fail in routing (5m buffer) so we check for diff < 5:
    getDistancesForNodeIdsWithRoutingRadiusTooSmallForPathShape(nodeCollection) {
        var _a;
        if (nodeCollection === void 0) { nodeCollection = (_a = this._collectionManager) === null || _a === void 0 ? void 0 : _a.get('nodes'); }
        const nodesDistancesFromAndDiffWithNodesRoutingRadii = this.getNodesDistancesFromPathWithNodesRoutingRadii(nodeCollection);
        const nodeIdsWithRoutingRadiusTooSmallForPathShape = {};
        for (let i = 0, count = nodesDistancesFromAndDiffWithNodesRoutingRadii.length; i < count; i++) {
            if (nodesDistancesFromAndDiffWithNodesRoutingRadii[i].routingRadiusMeters -
                nodesDistancesFromAndDiffWithNodesRoutingRadii[i].distanceMeters <
                5) {
                nodeIdsWithRoutingRadiusTooSmallForPathShape[nodesDistancesFromAndDiffWithNodesRoutingRadii[i].nodeId] =
                    nodesDistancesFromAndDiffWithNodesRoutingRadii[i].distanceMeters;
            }
        }
        return nodeIdsWithRoutingRadiusTooSmallForPathShape;
    }
    nodesGeojsons() {
        const nodeIds = this.attributes.nodes;
        const nodeTypes = this.attributes.data.nodeTypes;
        const nodesGeojsons = [];
        if (this._collectionManager.get('nodes')) {
            for (let i = 0, count = nodeIds.length; i < count; i++) {
                const nodeId = nodeIds[i];
                const nodeType = nodeTypes[i];
                const nodeGeojson = (0, cloneDeep_1.default)(this._collectionManager.get('nodes').getById(nodeId));
                nodeGeojson.properties.type = nodeType;
                nodesGeojsons.push(nodeGeojson);
            }
        }
        return nodesGeojsons;
    }
    waypointsGeojsons() {
        if (!this.allowsWaypoints()) {
            return [];
        }
        const waypointsByNodeIndex = this.attributes.data.waypoints || [];
        const waypointTypesByNodeIndex = this.attributes.data.waypointTypes || [];
        const features = [];
        let featureId = 1;
        const defaultRoutingType = this.attributes.data.routingEngine || 'engine';
        waypointsByNodeIndex.forEach((waypoints, afterNodeIndex) => {
            if (!waypoints) {
                waypoints = [];
            }
            waypoints.forEach((waypoint, waypointIndex) => {
                const waypointType = (0, get_1.default)(waypointTypesByNodeIndex, `[${afterNodeIndex}][${waypointIndex}]`, defaultRoutingType);
                features.push(turf_1.helpers.point(waypoint, { afterNodeIndex, waypointIndex, type: waypointType }, { id: featureId }));
                featureId++;
            });
        });
        return features;
    }
    emptyGeography() {
        const newData = {
            segments: null, // the last segment is the return back to first stop
            dwellTimeSeconds: null, // the last travel time is the travel time to go back to first stop
            layoverTimeSeconds: null,
            travelTimeWithoutDwellTimesSeconds: null,
            totalDistanceMeters: null,
            operatingTimeWithoutLayoverTimeSeconds: null,
            operatingTimeWithLayoverTimeSeconds: null,
            averageSpeedWithoutDwellTimesMetersPerSecond: null,
            operatingSpeedMetersPerSecond: null,
            operatingSpeedWithLayoverMetersPerSecond: null,
            segmentsByServiceAndPeriod: null,
            variables: {}
        };
        this.set('geography', null); // TODO: fix this, it should never be null when typing correctly, but setting coordinates to an empty array fails right now
        this.attributes.segments = [];
        this.attributes.data = Object.assign(this.attributes.data, newData);
        this._updateHistory();
    }
    /**
     * Get the geography between 2 nodes.
     *
     * @param nodeStartIndex The index of the node at the beginning of the
     * desired segment
     * @param nodeEndIndex The index of the node at the end of the desired
     * segment
     * @param properties Any additional property to add to the segment geojson
     * @returns A line string feature for the segment between nodes, or
     * undefined if the segment has no geometry or indexes are invalid
     * @throws TrError with code `PathNoGeography` if the path has no geography,
     * or `PathInvalidSegmentIndex` if the start/end nodes are invalid
     */
    segmentGeojson(nodeStartIndex, nodeEndIndex, properties = {}) {
        var _a;
        if (this.attributes.geography === undefined) {
            throw new TrError_1.default('Path has no geography', 'PathNoGeography');
        }
        if (nodeStartIndex > this.attributes.segments.length || nodeStartIndex >= nodeEndIndex) {
            throw new TrError_1.default('Path segment geojson: invalid start index', 'PathInvalidSegmentIndex');
        }
        if (properties.color === undefined) {
            properties.color = this.get('color', (_a = this.getLine()) === null || _a === void 0 ? void 0 : _a.get('color'));
        }
        const pathCoordinates = this.attributes.geography.coordinates;
        const pathSegments = this.attributes.segments;
        const pathCoordinatesStartIndex = pathSegments[nodeStartIndex];
        let pathCoordinatesEndIndex;
        if (!(0, LodashExtensions_1._isBlank)(pathSegments[nodeEndIndex])) {
            // last coordinate
            pathCoordinatesEndIndex = pathSegments[nodeEndIndex];
        }
        else {
            // last segment:
            pathCoordinatesEndIndex = pathCoordinates.length - 1;
        }
        const segmentCoordinates = pathCoordinates.slice(pathCoordinatesStartIndex, pathCoordinatesEndIndex + 1); // slice does not include end index
        // Make sure there are coordinates. If only one, repeat the coordinate to have a 0-length line string
        if (segmentCoordinates.length < 1) {
            throw new TrError_1.default('Path segment geojson: invalid line string length', 'PathInvalidSegmentIndex');
        }
        else if (segmentCoordinates.length === 1) {
            segmentCoordinates.push(segmentCoordinates[0]);
        }
        return {
            type: 'Feature',
            id: this.attributes.integer_id,
            properties,
            geometry: {
                type: 'LineString',
                coordinates: segmentCoordinates
            }
        };
    }
    refreshStats() {
        const variables = {
            d_p: (0, MathUtils_1.roundToDecimals)(this.attributes.data.totalDistanceMeters || ''),
            n_q_p: this.countNodes(),
            d_l_min: null,
            d_l_max: null,
            d_l_avg: null,
            d_l_med: null,
            T_o_p: this.attributes.data.operatingTimeWithoutLayoverTimeSeconds
        };
        const segmentLengths = (this.attributes.data.segments || [])
            .map((segment) => {
            return segment.distanceMeters;
        })
            .filter((distance) => distance !== null);
        if (segmentLengths.length > 0) {
            variables.d_l_min = (0, MathUtils_1.ceilToPositiveInteger)(Math.min(...segmentLengths));
            variables.d_l_max = (0, MathUtils_1.ceilToPositiveInteger)(Math.max(...segmentLengths));
            variables.d_l_avg = (0, MathUtils_1.roundToDecimals)((0, mean_1.default)(segmentLengths), 0);
            variables.d_l_med = (0, MathUtils_1.roundToDecimals)((0, MathUtils_1.median)(segmentLengths), 0);
        }
        this.attributes.data.variables = variables;
    }
    updateGeography(changesInfo) {
        // _forceRecalculate: set by the UI toggle, affects all operations (insert/remove/waypoint)
        // changesInfo.forceRecalculate: passed directly by the recalculate route button
        const mergedChangesInfo = Object.assign(Object.assign({}, changesInfo), { forceRecalculate: this._forceRecalculate === true || (changesInfo === null || changesInfo === void 0 ? void 0 : changesInfo.forceRecalculate) === true });
        return (0, PathGeographyUtils_1.default)(this, mergedChangesInfo);
    }
    isComplete() {
        // at least 2 nodes and valid shapes and segments
        const nodesCount = this.countNodes();
        const dwellTimesSeconds = this.attributes.data.dwellTimeSeconds || [];
        const segments = this.attributes.data.segments || [];
        /*
        console.log(nodesCount < 2, _isBlank(this.get('direction')), !_isNumber(this.getData('totalDistanceMeters')), !_isNumber(this.getData('operatingTimeWithLayoverTimeSeconds')),
        !_isNumber(this.getData('travelTimeWithoutDwellTimesSeconds')), !_isNumber(this.getData('totalDwellTimeSeconds')), !_isNumber(this.getData('layoverTimeSeconds')), this.getData('routingFailed') === true,
        this.get('segments', []).length !== nodesCount - 1, dwellTimesSeconds.length !== nodesCount, segments.length !== nodesCount - 1, !isFeature(this.toGeojson()));
        */
        if (nodesCount < 2 ||
            (0, LodashExtensions_1._isBlank)(this.get('direction')) ||
            !(0, isFinite_1.default)(this.getData('totalDistanceMeters')) ||
            !(0, isFinite_1.default)(this.getData('operatingTimeWithLayoverTimeSeconds')) ||
            !(0, isFinite_1.default)(this.getData('travelTimeWithoutDwellTimesSeconds')) ||
            !(0, isFinite_1.default)(this.getData('totalDwellTimeSeconds')) ||
            !(0, isFinite_1.default)(this.getData('layoverTimeSeconds')) ||
            this.getData('routingFailed') === true ||
            this.attributes.segments.length !== nodesCount - 1 ||
            dwellTimesSeconds.length !== nodesCount ||
            segments.length !== nodesCount - 1) {
            return false;
        }
        for (let i = 0, count = nodesCount - 1; i < count; i++) {
            if (!(0, isFinite_1.default)(dwellTimesSeconds[i]) ||
                dwellTimesSeconds[i] < 0 ||
                !segments[i] ||
                !(0, isFinite_1.default)(segments[i].distanceMeters) ||
                segments[i].distanceMeters === null ||
                !(0, isFinite_1.default)(segments[i].travelTimeSeconds) ||
                segments[i].travelTimeSeconds < 0) {
                /*console.log(dwellTimesSeconds[i], segments[i])*/
                return false;
            }
        }
        return true;
    }
    // TODO: extract mode related validations to external function
    canRoute() {
        let canRoute = true;
        const errors = [];
        const pathData = this.attributes.data;
        if (this.countNodes() < 2) {
            canRoute = false;
            errors.push('transit:transitPath:errors:NeedAtLeast2NodesOrStops');
        }
        if (!this.get('direction')) {
            canRoute = false;
            errors.push('transit:transitPath:errors:DirectionIsRequired');
        }
        if ((['engineCustom', 'manual'].includes(pathData.routingEngine || '') || this.atLeastOneSegmentIsManual()) &&
            (0, LodashExtensions_1._isBlank)(pathData.defaultRunningSpeedKmH)) {
            canRoute = false;
            errors.push('transit:transitPath:errors:DefaultRunningSpeedIsRequiredForManualAndEngineCustomRoutingEngines');
        }
        if ((0, LodashExtensions_1._isBlank)(pathData.routingEngine)) {
            canRoute = false;
            errors.push('transit:transitPath:errors:RoutingEngineIsRequired');
        }
        if (['engineCustom', 'engine'].includes(pathData.routingEngine || '') && (0, LodashExtensions_1._isBlank)(pathData.routingMode)) {
            canRoute = false;
            errors.push('transit:transitPath:errors:RoutingModeIsRequired');
        }
        if ((0, isNumber_1.default)(pathData.defaultRunningSpeedKmH) &&
            (pathData.defaultRunningSpeedKmH <= 0 || pathData.defaultRunningSpeedKmH > 500)) {
            canRoute = false;
            errors.push('transit:transitPath:errors:DefaultRunningSpeedIsInvalid');
        }
        if ((0, isNumber_1.default)(pathData.defaultDwellTimeSeconds) &&
            (pathData.defaultDwellTimeSeconds <= 0 || pathData.defaultDwellTimeSeconds > 600)) {
            if (this.getMode() !== 'transferable' ||
                (this.getMode() === 'transferable' && pathData.defaultDwellTimeSeconds < 0)) {
                canRoute = false;
                errors.push('transit:transitPath:errors:MinDwellTimeIsInvalid');
            }
        }
        if (!(0, isNumber_1.default)(pathData.defaultAcceleration)) {
            canRoute = false;
            errors.push('transit:transitPath:errors:DefaultAccelerationIsRequired');
        }
        else {
            if (pathData.defaultAcceleration < 0) {
                canRoute = false;
                errors.push('transit:transitPath:errors:DefaultAccelerationIsInvalid');
            }
            else if (pathData.defaultAcceleration <= 0.3) {
                canRoute = false;
                errors.push('transit:transitPath:errors:DefaultAccelerationIsTooLow');
            }
            else if (pathData.defaultAcceleration > 1.5 && this.getMode() !== 'transferable') {
                canRoute = false;
                errors.push('transit:transitPath:errors:DefaultAccelerationIsTooHigh');
            }
        }
        if (!(0, isNumber_1.default)(pathData.defaultDeceleration)) {
            canRoute = false;
            errors.push('transit:transitPath:errors:DefaultDecelerationIsRequired');
        }
        else {
            if (pathData.defaultDeceleration < 0) {
                canRoute = false;
                errors.push('transit:transitPath:errors:DefaultDecelerationIsInvalid');
            }
            else if (pathData.defaultDeceleration <= 0.3) {
                canRoute = false;
                errors.push('transit:transitPath:errors:DefaultDecelerationIsTooLow');
            }
            else if (pathData.defaultDeceleration > 1.5 && this.getMode() !== 'transferable') {
                canRoute = false;
                errors.push('transit:transitPath:errors:DefaultDecelerationIsTooHigh');
            }
        }
        if ((0, isNumber_1.default)(pathData.defaultRunningSpeedKmH) &&
            (0, isNumber_1.default)(pathData.maxRunningSpeedKmH) &&
            pathData.defaultRunningSpeedKmH > pathData.maxRunningSpeedKmH) {
            canRoute = false;
            errors.push('transit:transitPath:errors:DefaultRunningSpeedIsTooHigh');
        }
        const travelTimeWithoutDwellTimesSeconds = this.attributes.data.travelTimeWithoutDwellTimesSeconds;
        const operatingSpeedMetersPerSecond = this.attributes.data.operatingSpeedMetersPerSecond;
        const operatingTimeWithoutLayoverTimeSeconds = this.attributes.data.operatingTimeWithoutLayoverTimeSeconds;
        if (this.attributes.nodes.length >= 2 &&
            this.attributes.geography &&
            (!travelTimeWithoutDwellTimesSeconds ||
                (0, LodashExtensions_1._isBlank)(travelTimeWithoutDwellTimesSeconds) ||
                isNaN(travelTimeWithoutDwellTimesSeconds) ||
                !operatingSpeedMetersPerSecond ||
                (0, LodashExtensions_1._isBlank)(operatingSpeedMetersPerSecond) ||
                isNaN(operatingSpeedMetersPerSecond) ||
                !operatingTimeWithoutLayoverTimeSeconds ||
                (0, LodashExtensions_1._isBlank)(operatingTimeWithoutLayoverTimeSeconds) ||
                isNaN(operatingTimeWithoutLayoverTimeSeconds))) {
            this.attributes.data.routingFailed = true;
            canRoute = false;
        }
        return {
            canRoute,
            errors
        };
    }
    validate() {
        var _a;
        super.validate();
        const data = this.attributes.data;
        const canRouteResults = this.canRoute();
        this._isValid = this._isValid && canRouteResults.canRoute;
        this._errors = canRouteResults.errors;
        if (data.routingFailed === true) {
            this._isValid = false;
            this._errors.push(((_a = data.geographyErrors) === null || _a === void 0 ? void 0 : _a.error) ? data.geographyErrors.error : 'transit:transitPath:errors:RoutingFailed');
        }
        return this._isValid;
    }
    addError(message) {
        if (!this.errors) {
            this.errors = [];
        }
        if (!this.errors.includes(message)) {
            this.errors.push(message);
        }
    }
    removeError(message) {
        if (!this.errors) {
            this.errors = [];
        }
        const errorIndex = this.errors.indexOf(message);
        if (errorIndex >= 0) {
            this.errors.splice(errorIndex, 1);
        }
    }
    getDwellTimeSecondsAtNode(nodeDwellTimeSeconds) {
        const defaultGeneralDwellTimeSeconds = Math.max(0, Preferences_1.default.get('transit.nodes.defaultDwellTimeSeconds', 20));
        const pathDwellTimeSeconds = Math.max(0, this.getData('defaultDwellTimeSeconds', defaultGeneralDwellTimeSeconds));
        if (this.getData('ignoreNodesDefaultDwellTimeSeconds', false) === true) {
            return pathDwellTimeSeconds;
        }
        const defaultNodeDwellTime = nodeDwellTimeSeconds !== undefined && nodeDwellTimeSeconds >= 0
            ? nodeDwellTimeSeconds
            : defaultGeneralDwellTimeSeconds;
        return (0, MathUtils_1.ceilToPositiveInteger)(Math.max(defaultNodeDwellTime, pathDwellTimeSeconds));
    }
    getTemporalTortuosity() {
        if (this.countNodes() < 2) {
            return null;
        }
        if ((0, isFinite_1.default)(this.attributes.data.operatingTimeWithoutLayoverTimeSeconds) &&
            (0, isFinite_1.default)(this.attributes.data.directRouteBetweenTerminalsTravelTimeSeconds)) {
            const nodes = this.attributes.nodes;
            if (nodes[0] === nodes[this.countNodes() - 1]) {
                return null; // loop
            }
            return ((this.attributes.data.operatingTimeWithoutLayoverTimeSeconds || 0) /
                this.attributes.data.directRouteBetweenTerminalsTravelTimeSeconds);
        }
        return null;
    }
    getTemporalTortuosityWithoutDwellTimes() {
        if (this.countNodes() < 2) {
            return null;
        }
        if (this.countNodes() === 2) {
            return 1.0;
        }
        if ((0, isFinite_1.default)(this.attributes.data.travelTimeWithoutDwellTimesSeconds) &&
            (0, isFinite_1.default)(this.attributes.data.directRouteBetweenTerminalsTravelTimeSeconds)) {
            const nodes = this.attributes.nodes;
            if (nodes[0] === nodes[this.countNodes() - 1]) {
                return null; // loop
            }
            return (this.attributes.data.travelTimeWithoutDwellTimesSeconds /
                this.attributes.data.directRouteBetweenTerminalsTravelTimeSeconds);
        }
        return null;
    }
    getSpatialTortuosity() {
        if (this.countNodes() < 2) {
            return null;
        }
        if (this.countNodes() === 2) {
            return 1.0;
        }
        const nodes = this.attributes.nodes;
        if ((0, isFinite_1.default)(this.attributes.data.totalDistanceMeters) &&
            (0, isFinite_1.default)(this.attributes.data.directRouteBetweenTerminalsDistanceMeters)) {
            if (nodes[0] === nodes[this.countNodes() - 1]) {
                return null; // loop
            }
            return ((this.attributes.data.totalDistanceMeters || 0) /
                this.attributes.data.directRouteBetweenTerminalsDistanceMeters);
        }
        return null;
    }
    getEuclidianTortuosity() {
        const nodes = this.attributes.nodes;
        if (this.countNodes() < 2) {
            return null;
        }
        if ((0, isFinite_1.default)(this.attributes.data.totalDistanceMeters) &&
            (0, isFinite_1.default)(this.attributes.data.birdDistanceBetweenTerminals)) {
            if (nodes[0] === nodes[this.countNodes() - 1]) {
                return null; // loop
            }
            return ((this.attributes.data.totalDistanceMeters || 0) /
                this.attributes.data.birdDistanceBetweenTerminals);
        }
        return null;
    }
    getLine() {
        // TODO This class cannot type the Line (because Line has Path), so it should be getContainer or getParent
        if (this._collectionManager && this._collectionManager.get('lines')) {
            return this._collectionManager.get('lines').getById(this.get('line_id'));
        }
        else {
            return null;
        }
    }
    toString(showId = false) {
        const attributes = this.attributes;
        const name = attributes.name;
        if (name) {
            return `${name}` + (showId ? ` ${attributes.id}` : '');
        }
        return showId ? attributes.id : '';
    }
    countNodes() {
        return this.attributes.nodes.length;
    }
    averageSegmentLengthMeters() {
        if (this.isComplete()) {
            return (0, MathUtils_1.ceilToPositiveInteger)((this.attributes.data.totalDistanceMeters || 0) / (this.countNodes() - 1));
        }
        return null;
    }
    medianSegmentLengthMeters() {
        return (0, MathUtils_1.median)(this.getSegmentLengths());
    }
    getSegmentLengths() {
        var _a;
        const SegmentLengths = [];
        if (this.isComplete()) {
            (_a = this.attributes.data.segments) === null || _a === void 0 ? void 0 : _a.forEach((segment) => {
                if (segment && segment.distanceMeters) {
                    SegmentLengths.push(segment.distanceMeters);
                }
            });
            return SegmentLengths;
        }
        return [];
    }
    hasNodeId(nodeId) {
        return (this.attributes.nodes || []).includes(nodeId);
    }
    getSegmentsTravelTimes() {
        const segmentsTravelTimes = [];
        if (this.isComplete()) {
            (this.attributes.data.segments || []).forEach((segment) => {
                if (segment && segment.travelTimeSeconds) {
                    segmentsTravelTimes.push(segment.travelTimeSeconds);
                }
            });
            return segmentsTravelTimes;
        }
        return null;
    }
    getTotalWeight() {
        let totalWeight = 0;
        (this.attributes.nodes || []).forEach((nodeId) => {
            var _a;
            const nodeWeight = (0, get_1.default)((_a = this._collectionManager) === null || _a === void 0 ? void 0 : _a.get('nodes').getById(nodeId), 'properties.data.weight', 1);
            totalWeight += nodeWeight;
        });
        return totalWeight;
    }
    atLeastOneSegmentIsManual() {
        const nodeTypes = this.attributes.data.nodeTypes || [];
        return nodeTypes.includes('manual');
    }
    getAverageRelativeWeight() {
        let totalRelativeWeight = 0;
        let allWeightsFound = this.countNodes() >= 1;
        (this.attributes.nodes || []).forEach((nodeId) => {
            const nodeRelativeWeight = (0, get_1.default)(this._collectionManager.get('nodes').getById(nodeId), 'properties.data.relativeWeight');
            if (nodeRelativeWeight) {
                totalRelativeWeight += (0, get_1.default)(this._collectionManager.get('nodes').getById(nodeId), 'properties.data.relativeWeight');
            }
            else {
                allWeightsFound = false;
            }
        });
        return allWeightsFound ? totalRelativeWeight / this.countNodes() : null;
    }
    getMode() {
        const line = this.getLine();
        return line ? line.attributes.mode : this.attributes.mode;
    }
    /**
     * Whether this path's transit mode accepts waypoints between nodes.
     * Gondola (aerial tram / ropeway) cables run straight between stations.
     * @returns False when the mode config sets `allowsWaypoints` to false
     */
    allowsWaypoints() {
        const modeConfig = lineModesConfigByMode[this.getMode()];
        return !modeConfig || modeConfig.allowsWaypoints !== false;
    }
    countStops() {
        const stopIds = this.attributes.stops;
        if (stopIds) {
            return stopIds.length;
        }
        return 0;
    }
    getCoordinatesDistanceTraveledMeters() {
        const geography = this.attributes.geography;
        if (!geography || !geography.coordinates) {
            return [];
        }
        const coordinates = geography.coordinates;
        let distanceTravelSoFarMeters = 0;
        const distancesTraveledMeters = [];
        for (let i = 0, count = coordinates.length; i < count; i++) {
            const coordinate = coordinates[i];
            if (i > 0) {
                distanceTravelSoFarMeters += (0, turf_1.distance)(turf_1.helpers.point(coordinates[i - 1]), turf_1.helpers.point(coordinate), { units: 'meters' });
            }
            distancesTraveledMeters.push(distanceTravelSoFarMeters);
        }
        return distancesTraveledMeters;
    }
    static fromGeojson(geojsonFeature, isNew = false, collectionManager) {
        const path = new Path(geojsonFeature.properties, isNew, collectionManager);
        path.attributes.geography = geojsonFeature.geometry;
        return path;
    }
    static symbol() {
        return 'p';
    }
    delete(socket) {
        return new Promise((resolve, _reject) => {
            var _a;
            const line = this.getLine();
            SaveUtils_1.default.delete(this, socket, 'transitPath', (_a = this._collectionManager) === null || _a === void 0 ? void 0 : _a.get('paths')).then((response) => {
                if (Status.isStatusOk(response) && Status.unwrap(response).id !== undefined) {
                    if (line) {
                        line.attributes.path_ids = line.attributes.path_ids.filter((pathId) => {
                            return pathId !== this.id;
                        });
                        // FIXME This should be one method only, to refresh the line from server
                        line.refreshPaths();
                        line.refreshStats();
                        line.refreshSchedules(socket).then(() => {
                            line.save(socket).then((_lineSaveResponse) => {
                                resolve(response);
                            });
                        });
                    }
                    else {
                        resolve(response);
                    }
                }
                else {
                    resolve(response);
                }
            });
        });
    }
    save(socket) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.hasChanged() || this.isNew()) {
                this.refreshStats();
                return new Promise((resolve, _reject) => {
                    var _a;
                    const line = this.getLine();
                    this.attributes.mode = this.getMode(); // force add mode since it could have been removed when updating
                    SaveUtils_1.default.save(this, socket, 'transitPath', (_a = this._collectionManager) === null || _a === void 0 ? void 0 : _a.get('paths')).then((response) => {
                        if (!response.error) {
                            if (line) {
                                if (!line.attributes.path_ids.includes(this.id)) {
                                    line.attributes.path_ids.push(this.id);
                                }
                                /*if (line.getScheduledPathIds().includes(this.id))
                            {
                              line.needToUpdateSchedules([this.id]);
                            }*/
                                // TODO Use an update callback
                                line.refreshPaths();
                                line.refreshStats();
                                line.save(socket).then((_lineSaveResponse) => {
                                    resolve(response);
                                });
                            }
                            else {
                                resolve(response);
                            }
                        }
                        else {
                            resolve(response);
                        }
                    });
                });
            }
            else {
                return { id: this.id };
            }
        });
    }
    saveInMemory() {
        var _a;
        SaveUtils_1.default.saveInMemory(this, (_a = this._collectionManager) === null || _a === void 0 ? void 0 : _a.get('nodes'));
    }
    deleteInMemory() {
        var _a;
        SaveUtils_1.default.deleteInMemory(this, (_a = this._collectionManager) === null || _a === void 0 ? void 0 : _a.get('paths'));
    }
    static getPluralName() {
        return 'paths';
    }
    static getCapitalizedPluralName() {
        return 'Paths';
    }
    static getDisplayName() {
        return Path.displayName;
    }
}
exports.Path = Path;
Path.displayName = 'Path';
exports.default = Path;
//# sourceMappingURL=Path.js.map